import React from 'react';
import { useIsFoodMenuTabFlow } from '../../data/domains/config';
import LegacyFoodItemDetailScreen from '../../menu/FoodItemDetailScreen';
import WipFoodItemDetailScreen from '../../foodMenu/FoodItemDetailScreen';

/** Picks menu vs foodMenu detail screen from `menu_page_style` (type3 / type4 → food). */
export function ResolvedFoodItemDetailScreen() {
  const use_food_menu_stack = useIsFoodMenuTabFlow();
  const Screen = use_food_menu_stack ? WipFoodItemDetailScreen : LegacyFoodItemDetailScreen;
  return <Screen />;
}

export default ResolvedFoodItemDetailScreen;
